import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { Loader } from '@repo/ui';
import { useIsMobile } from '@repo/mui-config/hooks';

import { useLoanProcessSetCurrentModalState } from '@/components/loan-process/hooks/use-loan-process-set-current-modal-state';
import { LoanProcessModalHeader } from '@/components/loan-process/loan-process-modal/loan-process-modal-header';

export function ApplicationProcessing() {
  const isMobile = useIsMobile();
  useLoanProcessSetCurrentModalState('ApplicationProcessing');
  const { t } = useTranslation();

  return (
    <Box data-testid="application-processing" sx={{ px: isMobile ? 2 : 4, py: 4 }}>
      <LoanProcessModalHeader containerSx={{ mb: isMobile ? 4 : 8 }} />
      <Stack alignContent="center" alignItems="center">
        <Typography component="p" textAlign="center" variant="h5">
          {t('loanProcess.loanSteps.application.processing.title')}
        </Typography>
        <Typography sx={{ marginY: 2 }} textAlign="center">
          {t('loanProcess.loanSteps.application.processing.description')}
        </Typography>
        <Loader size={100} sx={{ marginY: '80px' }} />
      </Stack>
    </Box>
  );
}
